// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tKak","selected":"styles_selected__96-DP"};